var getStateKey = function getStateKey(renderedElement) {
  return typeof renderedElement.ref === 'string' ? renderedElement.ref : renderedElement.key;
};

export default getStateKey;


//////////////////
// WEBPACK FOOTER
// ./node_modules/radium/es/get-state-key.js
// module id = 235
// module chunks = 0